export default "__VITE_ASSET__4pN1sbI2__"